import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../types';
import { PLACEHOLDER_IMG } from '../utils/constants';
import './ProductCard.css';

interface ProductCardProps {
  product: Product;
  dark?:   boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, dark = false }) => {
  const discount = product.mrp > product.price
    ? Math.round((1 - product.price / product.mrp) * 100)
    : 0;

  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>): void => {
    e.currentTarget.src = PLACEHOLDER_IMG;
  };

  return (
    <Link to={`/product/${product.id}`} className={`product-card ${dark ? 'dark' : ''}`}>
      <div className="card-img-wrap">
        <img src={product.image} alt={product.name} loading="lazy" onError={handleImgError} />
        {discount > 0 && <span className="discount-badge">{discount}% OFF</span>}
        {product.quantity === 0 && <div className="out-of-stock-overlay">Out of Stock</div>}
        <div className="card-overlay" aria-hidden="true">
          <span className="quick-view-btn">Quick View</span>
        </div>
      </div>
      <div className="card-body">
        <span className="badge badge-category">{product.category}</span>
        <p className="card-name">{product.name}</p>
        <div className="card-price">
          <span className="price-sale">₹{product.price.toLocaleString('en-IN')}</span>
          {product.mrp > product.price && (
            <span className="price-mrp">₹{product.mrp.toLocaleString('en-IN')}</span>
          )}
          {discount > 0 && <span className="price-discount">{discount}% off</span>}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
